import React from 'react';
import { Button, Tooltip, useCopyToClipboard, useMediaQueryContext } from '@fourthwall/components';
import * as S from './CopyInput.styled';
export const CopyInput = ({ url }) => {
    const media = useMediaQueryContext();
    const { isCopied, copyToClipboard } = useCopyToClipboard({
        toastMessage: !media.laptop ? 'Link copied to clipboard' : undefined,
    });
    return (React.createElement(S.Container, null,
        React.createElement(S.Inner, null,
            React.createElement(S.Label, null, "Members-only audio RSS link"),
            React.createElement(S.Url, null, url)),
        React.createElement(Tooltip, { reference: React.createElement(Button, { appearance: "secondary", label: "Copy URL", fullWidth: true, onClick: () => copyToClipboard(url) }) }, isCopied ? 'Copied!' : 'Copy link')));
};
